// Shared "Last updated Xm ago" badge for Meta data surfaces. Reads
// cache_meta from any Meta endpoint response and renders a small pill
// colored by staleness: green <15m, amber 15-30m, red >30m (poller
// likely in backoff).

import { useEffect, useState } from 'react';

export function FreshnessBadge({ cacheMeta, label = 'Meta data' }) {
  // Re-render every 30s so the "Xm ago" stays current without refetching.
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, []);

  if (!cacheMeta?.last_success_at) {
    return (
      <span className="text-[10px] px-2 py-0.5 rounded bg-muted text-muted-foreground">
        {label}: no data yet
      </span>
    );
  }
  const last = new Date(cacheMeta.last_success_at);
  const ageMs = Date.now() - last.getTime();
  const ageMin = Math.floor(ageMs / 60000);
  const tone = ageMin < 15
    ? 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400'
    : ageMin < 30
      ? 'bg-amber-500/10 text-amber-700 dark:text-amber-400'
      : 'bg-destructive/10 text-destructive';
  const errors = cacheMeta.consecutive_errors || 0;
  const fmtAge = ageMin < 1 ? 'just now' : ageMin < 60 ? `${ageMin}m ago` : `${Math.floor(ageMin / 60)}h ${ageMin % 60}m ago`;
  return (
    <span
      title={`${label} cached ${fmtAge}${errors > 0 ? ` · ${errors} consecutive errors` : ''}`}
      className={`text-[10px] px-2 py-0.5 rounded inline-flex items-center gap-1 ${tone}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${ageMin < 15 ? 'bg-emerald-500' : ageMin < 30 ? 'bg-amber-500' : 'bg-destructive'}`} />
      Updated {fmtAge}
    </span>
  );
}
